import { RowScheduleCompanyDto } from "@/dtos";
import { Company, ScheduleCompany } from "@/entities";

export const formatRowScheduleCompanyDto = (scheduleCompany: ScheduleCompany, company: Company): RowScheduleCompanyDto => {
    const row: RowScheduleCompanyDto = {
        ...scheduleCompany,
        active: (scheduleCompany.is_active) ? 'Activo' : 'Inactivo',
        company: company.name,
        company_id: company.id
    }
    
    return row;
}